package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_02_14_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Stadler Fayless arrives at the gate to the heroes’ bastion promptly at 8 a.m.  Annette draws up a contract based on Tuesday’s suggestion: “2,000 gold left with Stadler from which he can draw his own pay and hire additional permanent staff and temporary workers. He mentions a couple of priorities:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a cleaner,")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("new bedding, and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("repairing the barracks basement and foundation.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper and Tuesday act crazy for a while. Caper seems intent on mastering pirate cosplay.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes walk to the Leaping Ram inn to pick up Aloysius, the battle cow, and Flower, the horse. They spot a few Barrowmen on their way out of the bastion. At the Leaping Ram, the heroes talk to Lornella Dabrin. Their walk across town took longer than they expected, so they pay to have Flower delivered to their bastion’s stables. Korvis casts Wind Walk, and the heroes and Aloysius travel to the docks.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At the end of the dock, the heroes see a decent-looking double-masted ship titled “The Cloud Chaser.” A female Drow is barking orders. She is dressed in leather with a wide-rimmed hat with a feather and a scarf. She stops and introduces herself as Captain Leah L’Seth. The journey will take one week. They are shipping tobacco and Southern fruits. Captain L’Seth introduces the crew: *Droo, the half Orc male;")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sparrow, a Halfling lady;")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Hanon, a young man; and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Zen, a male Drow wearing two sabers as her crew chief.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dirk makes unwelcome advances toward Leah; she shows no interest. With Tuesday’s “Reduce spell” help, Caper takes Aloysius, the battle cow, below deck to the animal stall. Zen appears linked to Leah, spiritually? As if they move together. Caper and Tuesday climb/fly to the crows’ nests. The ship passes by Tungle, the last significant port before Ostvel.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Some cartographers misspell Tu")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("n")
            }
            org.jetbrains.compose.web.dom.Text("gle as Turgle.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the night watch, Tuesday again hears flapping wings of a giant creature.")
    }
}
